import { EKanbanCardProperty } from '../../../../../../../../types/types';

export const getToggledProperties = (
    properties: EKanbanCardProperty[],
    property: EKanbanCardProperty,
) => {
    if (properties.includes(property)) {
        properties = properties.filter(item => item !== property);
    } else {
        properties = [...properties, property];
    }
    return properties;
}
